import { z } from 'zod';
import { notificationsContextValues } from 'src/apis/notification-service/mappings';
import { searchableSingleSelectBaseSchema } from 'src/components/form/select/searchable-single-select';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

function getNotificationsPageParamsSchema() {
  return z.object({
    lastSeenAt: z.string().nullable().default(null),
    lastSeenId: z.string().nullable().default(null),
    size: z.coerce.number().default(10),
    context: z.enum(notificationsContextValues).nullable().default(null),
    actorUserId: searchableSingleSelectBaseSchema.nullable().default(null),
    counterpartyOrganisationId: searchableSingleSelectBaseSchema
      .nullable()
      .default(null),
    notificationDateFrom: z.string().nullable().default(null),
    notificationDateTo: z.string().nullable().default(null),
  });
}

export function useNotificationsPageParams() {
  return usePageParamsFromSchema(getNotificationsPageParamsSchema(), {
    filters: {
      context: { label: 'Context' },
      actorUserId: { label: 'Acting User' },
      counterpartyOrganisationId: { label: 'Counterparty' },
      notificationDateFrom: { label: 'Activity Date' },
      notificationDateTo: { label: 'Activity Date' },
    },
  });
}

export type NotificationsPageParams = ReturnType<
  typeof useNotificationsPageParams
>;
